// extracted by mini-css-extract-plugin
export default {"gws-promocode-wizard":"PromoCodeOptions_gws-promocode-wizard__lLLGh","gws-promocode__items":"PromoCodeOptions_gws-promocode__items__JwUze","active":"PromoCodeOptions_active__1l1PS"};